import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { useMemo } from 'react';
import { Table } from 'antd';
import { renderColumns } from './columns';
import { styled } from '@xstyled/styled-components';
import { styleVariables } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledTableWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);\n  border: 1px solid ", ";\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n\n  .ant-table-thead > tr > th {\n    padding: 12px 16px !important;\n    font-size: 13px;\n    white-space: nowrap;\n  }\n\n  .ant-table-wrapper {\n    height: 100%;\n    overflow: hidden;\n  }\n  .ant-spin-nested-loading {\n    height: 100%;\n  }\n  .ant-spin-container {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n  .ant-table {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n  }\n  .ant-table-container {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n  }\n  .ant-table-body {\n    flex: 1;\n    overflow-y: auto !important;\n    max-height: 100% !important;\n  }\n"])), styleVariables.colors.gray5);
export var TableParticipatedAssignment = function TableParticipatedAssignment(_ref) {
  var dataSources = _ref.dataSources,
      columnLabels = _ref.columnLabels,
      navigateToSubmissionDetail = _ref.navigateToSubmissionDetail;
  var columns = useMemo(function () {
    return renderColumns({
      navigateToSubmissionDetail: navigateToSubmissionDetail,
      columnLabels: columnLabels
    });
  }, [navigateToSubmissionDetail, columnLabels]);
  return /*#__PURE__*/_jsx(StyledTableWrapper, {
    children: /*#__PURE__*/_jsx(Table, {
      dataSource: dataSources,
      columns: columns,
      pagination: false,
      rowKey: function rowKey(record) {
        return record.id.toString();
      },
      scroll: {
        y: '100%'
      }
    })
  });
};